import React from 'react'
import useJoinLink from '../../../pages/fund/joinFundByLink/hooks/useJoinLink'
import { useParams } from 'react-router-dom'
import DotsLoading from '../../../components/loadings/dotsLoading'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'

export default function JoinLink() {
    const { id } = useParams()
    const { joinLink, isLoadingJoinLink } = useJoinLink(id)
    return (
        <>
            {isLoadingJoinLink ? (
                <div className="flex items-center justify-center">
                    <DotsLoading />
                </div>
            ) : (
                <div>
                    <p className=" text-center mb-3">
                        اشتراک گذاری لینک عضویت در صندوق
                    </p>
                    <hr />
                    <div className=" my-4 px-3 text-center">
                        <p
                            onClick={() => {
                                posthog.capture('fund_member_invited', {
                                    fund_id: id,
                                })
                                navigator.clipboard.writeText(joinLink)
                                toast.success('با موفقیت کپی شد')
                            }}
                        >
                            کپی لینک
                        </p>
                    </div>
                </div>
            )}
        </>
    )
}
